<script setup lang="ts">
import { AppText } from '@shared/ui/typography'

import { useTutorLegalUploadedFiles } from '../../model/legal/tutor-legal-uploaded-files.hook'
import TutorLegalFileItem from './TutorLegalFileItem.vue'

defineOptions({
  name: 'TutorLegalUploadedFiles',
})

const {
  files,
  removeFile,
} = useTutorLegalUploadedFiles()
</script>

<template>
  <div
    v-if="files.length"
    class="tutor-legal-uploaded"
  >
    <AppText
      name="body1-medium"
      color="slate-900"
    >
      Uploaded files
    </AppText>
    <div class="tutor-legal-uploaded__list">
      <TutorLegalFileItem
        v-for="file in files"
        :key="file.id"
        :file="file"
        @remove="removeFile(file.id)"
      />
    </div>
  </div>
</template>

<style lang="scss" scoped src="./TutorLegalUploadedFiles.scss" />
